import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0B1120] text-slate-300" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif', color: '#B4905A' }}>
              TRADEMARK COMPANY
            </div>
            <p className="text-sm leading-relaxed mb-6">
              Your trusted partner for comprehensive trademark, copyright, and intellectual property services in the United States. Protecting your brand since day one.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-white mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Our Services
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/trademark-registration" className="hover:text-[#B4905A] transition-colors text-sm" data-testid="footer-service-trademark">
                  Trademark Registration
                </Link>
              </li>
              <li>
                <Link to="/copyright-registration" className="hover:text-[#B4905A] transition-colors text-sm" data-testid="footer-service-copyright">
                  Copyright Registration
                </Link>
              </li>
              <li>
                <Link to="/company-formation" className="hover:text-[#B4905A] transition-colors text-sm" data-testid="footer-service-company">
                  Company Formation
                </Link>
              </li>
              <li>
                <Link to="/trademark-search" className="hover:text-[#B4905A] transition-colors text-sm" data-testid="footer-service-search">
                  Trademark Search
                </Link>
              </li>
              <li>
                <Link to="/amazon-brand-registry" className="hover:text-[#B4905A] transition-colors text-sm" data-testid="footer-service-amazon">
                  Amazon Brand Registry
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-white mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="hover:text-[#B4905A] transition-colors text-sm">
                  About Us
                </a>
              </li>
              <li>
                <a href="#pricing" className="hover:text-[#B4905A] transition-colors text-sm">
                  Pricing
                </a>
              </li>
              <li>
                <a href="#faqs" className="hover:text-[#B4905A] transition-colors text-sm">
                  FAQs
                </a>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:text-[#B4905A] transition-colors text-sm" data-testid="footer-privacy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-[#B4905A] transition-colors text-sm" data-testid="footer-terms">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-white mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-[#B4905A] flex-shrink-0 mt-0.5" />
                <span className="text-sm">19th Floors, 515 Flower St, Los Angeles, CA 90071</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-[#B4905A]" />
                <span className="text-sm">+1 (123) 123-4567</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-[#B4905A]" />
                <span className="text-sm">Info@trademarkcompanylogo.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 text-center">
          <p className="text-sm text-slate-400">
            © {new Date().getFullYear()} Trademark Company. All rights reserved. | USPTO Filing Experts
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
